import React, { useState, useRef, useEffect } from "react";
import { Icons } from "../assets/icons/Icons";
import { useFunds } from "../service";

export const Notifications = () => {
  const divRef = useRef(null);

  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "Withdraw",
      time: "15h ago",
      amount: "$150.55",
      description: "Lorem ipsum dolor sit amet, ",
      icon: "bi-google",
      iconColor: "gradient-orange",
    },
    {
      id: 8,
      title: "Congratulations",
      time: "14th March 10:25 AM",
      amount: "+0.315%",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore....",
      icon: "bi-caret-up-fill",
      iconColor: "gradient-green",
    },
    {
      id: 2,
      title: "Deposit",
      time: "14th March 10:25 AM",
      amount: "+0.315%",
      description: "Bill Payment",
      icon: "bi-caret-up-fill",
      iconColor: "gradient-green",
    },
    {
      id: 3,
      title: "Income",
      time: "5h ago",
      description: "Dividends",
      icon: "bi-pie-chart-fill",
      iconColor: "gradient-yellow",
    },
    {
      id: 4,
      title: "Income",
      time: "5h ago",
      description: "Dividends",
      icon: "bi-pie-chart-fill",
      iconColor: "gradient-yellow",
    },
    {
      id: 5,
      title: "Income",
      time: "5h ago",
      description: "Dividends",
      icon: "bi-pie-chart-fill",
      iconColor: "gradient-yellow",
    },
    {
      id: 6,
      title: "Income",
      time: "5h ago",
      description: "Dividends",
      icon: "bi-pie-chart-fill",
      iconColor: "gradient-yellow",
    },
    {
      id: 7,
      title: "Income",
      time: "5h ago",
      description: "Dividends",
      icon: "bi-pie-chart-fill",
      iconColor: "gradient-yellow",
    },
  ]);

  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(0);
  const [notificationPositions, setNotificationPositions] = useState({});
  const [selectedNotification, setSelectedNotification] = useState(null);
  const notificationRefs = useRef({});

  const { data: funds = [] } = useFunds()?.funds;

  useEffect(() => {
    const preventScroll = (event) => {
      event.preventDefault();
    };

    const div = divRef.current;
    if (div) {
      div.addEventListener("wheel", preventScroll, { passive: false });
    }

    return () => {
      if (div) {
        div.removeEventListener("wheel", preventScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (funds && funds.length > 0) {
      setNotifications((prevNotifications) =>
        prevNotifications.map((notification) => ({
          ...notification,
        }))
      );
    }
  }, [funds]);

  const handleMouseDown = (e, notificationId) => {
    setIsDragging(true);
    setDragStartX(e.clientX);
    if (selectedNotification != notificationId) {
      setNotificationPositions((prevPositions) => ({
        ...prevPositions,
        [selectedNotification]: 0,
      }));
    }
    setSelectedNotification(notificationId);
  };

  const handleMouseMove = (e) => {
    if (isDragging && selectedNotification !== null) {
      const moveDistance = e.clientX - dragStartX;

      if (Math.abs(moveDistance) > 20) {
        setNotificationPositions((prevPositions) => ({
          ...prevPositions,
          [selectedNotification]: 50,
        }));
        setIsDragging(false);
      } else {
        setNotificationPositions((prevPositions) => ({
          ...prevPositions,
          [selectedNotification]: 0,
        }));
      }
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);

    if (notificationPositions[selectedNotification] >= 50) {
      setNotificationPositions((prevPositions) => ({
        ...prevPositions,
        [selectedNotification]: 50,
      }));
    }
  };

  const handleNotificationClick = (notificationId) => {
    if (selectedNotification !== notificationId) {
      setNotificationPositions((prevPositions) => ({
        ...prevPositions,
        [selectedNotification]: 0,
      }));
      setNotificationPositions((prevPositions) => ({
        ...prevPositions,
        [notificationId]: 0,
      }));
      setSelectedNotification(notificationId);
    }
  };

  const handleDeleteNotification = (notificationId) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter(
        (notification) => notification.id !== notificationId
      )
    );
    setSelectedNotification(null);
  };

  const handleOutsideClick = (e) => {
    if (selectedNotification !== null) {
      const notificationElement =
        notificationRefs.current[selectedNotification];
      const clickedOutside = !notificationElement.contains(e.target);

      if (clickedOutside) {
        setNotificationPositions((prevPositions) => ({
          ...prevPositions,
          [selectedNotification]: 0,
        }));
        setSelectedNotification(null);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [selectedNotification]);

  return (
    <div
      ref={divRef}
      className="offcanvas offcanvas-top rounded-m"
      id="menu-notifications"
      style={{
        height: "100vh",
        backgroundImage: "url('./images/store/notification_bg.png')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0px 0px",
        backgroundSize: "contain",
        backgroundColor: "#000000",
      }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          padding: "25px 15px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center gap-3">
          <a href="#" className="shadow-0" data-bs-dismiss="offcanvas">
            <Icons.CloseWithBG />
          </a>

          <p className="font-22 font-700 m-0" style={{ color: "#FFFFFF" }}>
            Notifications
          </p>
        </div>

        <p className="m-0" style={{ color: "rgba(44, 42, 209, 1)" }}>
          Clear All
        </p>
      </div>
      <div className="content pb-2">
        {notifications.map((notification) => (
          <div
            key={notification.id}
            ref={(el) => (notificationRefs.current[notification.id] = el)}
            className={`notification-${notification.id} d-flex`}
            onClick={() => handleNotificationClick(notification.id)}
            onMouseDown={(e) => handleMouseDown(e, notification.id)}
            style={{
              position: "relative",
            }}
          >
            <div
              style={{
                background: "rgba(20, 20, 20, 1)",
                padding: "10px",
                zIndex: "10",
                width: "100%",
                marginBottom: "13px",
                borderRadius: "12px",
                transform: `translateX(-${
                  notificationPositions[notification.id] || 0
                }px)`,
                cursor: "grab",
                transition: "transform 0.3s ease-out",
              }}
            >
              <div className="d-flex py-1">
                <div className="align-self-center me-3">
                  <Icons.NotificationCardBell />
                </div>
                <div style={{ width: "100%" }}>
                  <div className="d-flex justify-content-between ">
                    <h5 className="pt-1 m-0 p-0">{notification.title}</h5>
                    <p
                      className="mb-0 font-11"
                      style={{
                        color: "rgba(70, 64, 63, 1)",
                      }}
                    >
                      {notification.time}
                    </p>
                  </div>
                  <p
                    className="mb-0 font-11 m-0 p-0 mt-1"
                    style={{
                      color: "rgba(255, 255, 255, 0.6)",
                      fontSize: "15px",
                      lineHeight: "16px",
                      fontWeight: "400",
                    }}
                  >
                    {notification.description}
                  </p>
                </div>
              </div>
            </div>

            {/* Red background space for the delete button */}
            {selectedNotification === notification.id &&
              notificationPositions[notification.id] >= 50 && (
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    right: "0px",
                    width: "60px",
                    zIndex: "9",
                    height: "calc(100% - 13px)",
                    backgroundColor: "#D42C42",
                    borderTopRightRadius: "12px", // Border-radius applied to align with the notification's corner
                    borderBottomRightRadius: "12px", // Border-radius applied to align with the notification's corner
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background-color 0.3s ease-out",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteNotification(notification.id);
                  }}
                >
                  {/* Delete button centered inside the red space */}
                  <img
                    src="./images/store/red_bin.png"
                    alt="delete"
                    style={{
                      marginLeft: "7px",
                      width: "24px", // Adjust the size as per requirement
                      height: "24px", // Adjust the size as per requirement
                    }}
                  />
                </div>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};
